<template>
    <div v-if="hasIcons || hasDescription" class="row">
        <div class="col-lg-12 mb-2">
            <h4 class="font-weight-bold primary-heading text-lowercase patcraft-text-underline"
                :data-text="keyFeaturesText ? (keyFeaturesText.slice(0, 3)) : ''">
                {{ keyFeaturesText }}
            </h4>
        </div>
        <div class="col-lg-12 mb-4">
            <div v-html="keyFeaturesDescription"></div>
        </div>
        <div class="col-lg-12 mb-2">
            <div class="row d-flex flex-wrap align-items-baseline">
                <div v-for="(item, index) in productData.marketAttributeIcons" :key="index"
                    v-if="item.iconImageURL || item.description"
                    class="marketing-icon-container col-lg-3 col-md-4 col-sm-6 col-6 mb-4 pl-3">
                    <div class="d-flex flex-row key-feature-icons">
                        <img v-if="item.iconImageURL" class="market-icon-img" :src="item.iconImageURL" />
                        <span v-if="item.description" class="icon-description mt-2">{{ item.description }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            productData: "productDetail/productData",
            keyFeaturesDescription: "productDetail/keyFeaturesDescription",
        }),
        keyFeaturesText() {
            return "Key Features";
        },
        hasIcons() {
            return this.productData.marketAttributeIcons ? this.productData.marketAttributeIcons !== null || this.productData.marketAttributeIcons.length > 0 : false;
        },
        hasDescription() {
            if (this.keyFeaturesDescription !== null && this.keyFeaturesDescription !== "") {
                return true;
            }
        },
    },
};
</script>

<style></style>
